import { memo } from 'react';
import { useSelector } from 'react-redux';

import { PublicAnnotationComment } from '~/components/AnnotationsV2/AnnotationsAvatarsContainer/AnnotationAvatarContainer/components/PublicAnnotationComment';
import { PublicAnnotationsAvatars } from '~/components/AnnotationsV2/AnnotationsAvatarsContainer/components/PublicAnnotationsAvatars';
import { PublicFloatingCommentForm } from '~/components/AnnotationsV2/shared/PublicFloatingCommentForm';
import { MobileVideoVisualizerFooter } from '~/components/AssetModal/Visualizer/VideoVisualizer/MobileVideoVisualizerFooter';
import { NativeMobileVideoVisualizer } from '~/components/AssetModal/Visualizer/VideoVisualizer/NativeMobileVideoVisualizer';
import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { PublicAssetModalContentFooter } from '~/components/v2/components/asset-modal/desktop/content/footer/PublicAssetModalContentFooter';
import { usePublicVideoVisualizerClipMarkers } from '~/components/v2/components/asset-modal/visualizer/video/hooks/usePublicVideoVisualizerClipMarkers';
import { VideoVisualizer } from '~/components/v2/components/asset-modal/visualizer/video/VideoVisualizer';
import { centralizedClipSelector } from '~/store/centralizedClip/selectors';
import { isMobileAgent } from '~/utils/PlatformHelpers';
import { canEditAssetDiscussions } from '~/utils/permissions/assetPermissions';

export const PublicVideoVisualizer = memo(() => {
  if (isMobileAgent) {
    return <PublicNativeMobileVideoVisualizer />;
  }

  return <PublicNarrowDesktopVideoVisualizer />;
});

const PublicNativeMobileVideoVisualizer = memo(() => {
  const clip = useSelector(centralizedClipSelector);

  return <NativeMobileVideoVisualizer clip={clip} />;
});

PublicNativeMobileVideoVisualizer.displayName = 'PublicNativeMobileVideoVisualizer';

const PublicNarrowDesktopVideoVisualizer = memo(() => {
  const clip = useSelector(centralizedClipSelector);
  const { permissions } = usePublicPermissions();
  const { markers } = usePublicVideoVisualizerClipMarkers();
  const canEditDiscussions = canEditAssetDiscussions(permissions);

  return (
    <div className="flex size-full flex-col">
      <VideoVisualizer
        AnnotationsAvatars={PublicAnnotationsAvatars}
        AnnotationComment={PublicAnnotationComment}
        FloatingCommentForm={PublicFloatingCommentForm}
        canEditDiscussions={canEditDiscussions}
        className="!pt-0 !pb-0 min-h-0 flex-1"
        clip={clip}
        markers={markers}
      />
      <MobileVideoVisualizerFooter>
        <PublicAssetModalContentFooter includeThemeControls={false} />
      </MobileVideoVisualizerFooter>
    </div>
  );
});

PublicNarrowDesktopVideoVisualizer.displayName = 'PublicNarrowDesktopVideoVisualizer';

PublicVideoVisualizer.displayName = 'PublicVideoVisualizer';
